import { useState, useEffect } from 'react'
import { Typography, ToggleSwitch, Tooltip } from '@telus-uds/components-web'
import MemoIcon from '../MemoIcon/MemoIcon'
import { LegalTextRenderer } from '../../../utils/text/TextRenderer'

import { ToggleWrapper, ContentWrapper, TextContainer } from './Styles'
import { IIcon } from 'contentful-types'

type ToggleProps = {
  label: string
  labelBold: string
  a11y: string
  tooltipText: string
  active: boolean
  icon?: IIcon
  onToggle: () => void
}

const Toggle = ({ label, labelBold, a11y, tooltipText, active, icon, onToggle }: ToggleProps) => {
  const withLegal = (text) => {
    return text ? <LegalTextRenderer>{text}</LegalTextRenderer> : ''
  }
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    setLoaded(true)
  }, [])

  return (
    <div>
      <ToggleWrapper>
        <ContentWrapper>
          {icon && <MemoIcon icon={icon} />}
          <TextContainer>
            {label && (
              <Typography block variant={{ size: 'small' }} tokens={{ color: '#4B286D' }} align="left">
                {withLegal(label)} {tooltipText && <Tooltip content={tooltipText} />}
              </Typography>
            )}
            {labelBold && (
              <Typography block variant={{ size: 'small', bold: true }} tokens={{ color: '#4B286D' }} align="left">
                {withLegal(labelBold)} {tooltipText && !label && <Tooltip content={tooltipText} />}
              </Typography>
            )}
          </TextContainer>
          {loaded && (
            <ToggleSwitch initialValue={active} onChange={onToggle} tooltip={tooltipText} accessibilityLabel={a11y} />
          )}
        </ContentWrapper>
      </ToggleWrapper>
    </div>
  )
}

export default Toggle
